import{gql as e}from"@apollo/client";const t=e`
  mutation registerUser(
    $credential: CredentialInput!
    $customFields: [CustomFieldAnswerInputType]
    $generateLoginToken: Boolean = false
    $user: RegisterUserInputType!
  ) {
    register(credential: $credential, customFields: $customFields, generateLoginToken: $generateLoginToken, user: $user)
  }
`;export{t as REGISTER_USER_MUTATION};
//# sourceMappingURL=useRegisterUser.graphql.js.map
